import { ShoppingCart } from 'lucide-react'

interface NavBasketButtonProps {
	itemCount: number
	onClick: () => void
	isOrange?: boolean
}

const NavBasketButton = ({ itemCount, onClick, isOrange = false }: NavBasketButtonProps) => (
	<button
		onClick={onClick}
		className={`flex items-center text-xs font-headline font-bold gap-1 transition-all duration-1000 group/cartbutton
			md:hover:gap-2 md:hover:ease-hypereaseout ${isOrange ? 'text-orange' : 'text-white'}`}
	>
		<ShoppingCart className={`w-6 h-6 ${isOrange ? 'text-orange' : 'text-white'}`} />
		<div className="scale-100 transition-all duration-1000 md:group-hover/cartbutton:scale-150 md:group-hover/cartbutton:ease-hypereaseout">
			{itemCount}
		</div>
	</button>
)

export default NavBasketButton
